const MovementNavIcon = ({
  className = 'stroke-green-800'
}: {
  className: string
}) => (
  <svg
    width='24'
    height='27'
    viewBox='0 0 24 27'
    fill='none'
    className={className}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M20 2.59961H4C2.89543 2.59961 2 3.49504 2 4.59961V22.6901C2 23.7947 2.89543 24.6901 4 24.6901H20C21.1046 24.6901 22 23.7947 22 22.6901V4.59961C22 3.49504 21.1046 2.59961 20 2.59961Z'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
    <path
      d='M7 9.22681H12'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
    <path
      d='M16 9.22681H17'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
    <path
      d='M7 13.645H12'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
    <path
      d='M16 13.645H17'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
    <path
      d='M7 18.063H12'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
    <path
      d='M16 18.063H17'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
  </svg>
)

export default MovementNavIcon
